import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';

export enum LoginMenuTypeEnum {
    Always = 0,
    LoggedIn = 1,
    LoggedOut = 2,
}

export interface INavDataCexveg {
    loginMenuType?: LoginMenuTypeEnum;
    actionCode?: EnumCodigosTwTcAcciones;
    visibleAfterSearching?: boolean;
    isImportDetail?: boolean;
    isExportDetail?: boolean;
    isAtestacionDetail?: boolean;
    isCpeDetail?: boolean;
    isUserDetail?: boolean;
    isCamDetail?: boolean;
    isSolCamDetail?: boolean;
    isPeriodoDetail?: boolean;
    isContenidoDetail?: boolean;
    isRecintoDetail?: boolean;
    isUdInspeccionDetail?: boolean;
    isProgramaVerificacionDetail?: boolean;
    isRechazoTracesDetail?: boolean;
    isTrasladoTracesDetail?: boolean;

    name?: string;
    url?: string | any[];
    href?: string;
    icon?: string;

    title?: boolean;
    children?: INavDataCexveg[];
    variant?: string;

    divider?: boolean;
    class?: string;
}

export const navItems: INavDataCexveg[] = [
    {
        name: 'Menú',
        url: '/home',
        icon: 'fa fa-home',
        loginMenuType: LoginMenuTypeEnum.Always,
        /*badge: {
          variant: 'info',
          text: 'NEW'
        }*/
    },

    // CAMPAÑAS, RECINTOS, CULTIVOS, UNIDADES DE INSPECCIÓN
    {
        title: true,
        name: 'Campañas',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_CAMPANIA_GENERAL,
    },

    // RECINTOS, CULTIVOS
    {
        name: 'Recintos',
        url: '/campanias/recintos',
        icon: 'icon-buscador_recintos',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_RECINTO_CAMPANIA,
    },
    {
        name: 'Recinto',
        url: '/campanias/recinto',
        icon: 'icon-recinto',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.MENU_RECINTO_CAMPANIA,
        children: [
            {
                name: 'Datos Básicos',
                url: '/campanias/recinto/edit',
                icon: 'icon-datos_basicos',
                isRecintoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_RECINTO_CAMPANIA,
            },
            {
                name: 'Cultivos',
                url: '/campanias/recinto/cultivos',
                icon: 'icon-cultivos',
                isRecintoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_CULTIVO_CAMPANIA,
            },
        ],
    },

    // SOLICITUDES DE CAMPAÑA
    {
        name: 'Solicitudes',
        url: '/campanias/solicitudes',
        icon: 'icon-buscador_solicitudes_campanias',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_SOL_CAM,
    },
    {
        name: 'Solicitud',
        url: '/campanias/solicitud',
        icon: 'icon-campania',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.MENU_SOL_CAM,
        children: [
            {
                name: 'Datos Básicos',
                url: '/campanias/solicitud/datosbasicos/detail',
                icon: 'icon-datos_basicos',
                isSolCamDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BAS_SOL_CAM,
            },
            {
                name: 'Recintos "PIAEd"',
                url: '/campanias/solicitud/recintos',
                icon: 'icon-recintos_pia',
                isSolCamDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_REC_PIA_SOL_CAM,
            },
            {
                name: 'Documentación',
                url: '/campanias/solicitud/documentacion',
                icon: 'icon-documentos',
                isSolCamDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DOC_SOL_CAM,
            },
            {
                name: 'Envío',
                url: '/campanias/solicitud/envio',
                icon: 'icon-envios',
                isSolCamDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_SEND_SOL_CAM,
            },
            {
                name: 'Validación - Aceptación',
                url: '/campanias/solicitud/validacion',
                icon: 'icon-validacion_aceptacion',
                isSolCamDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_VAL_ACCEPT_SOL_CAM,
            },
        ],
    },

    // UNIDADES DE INSPECCIÓN
    {
        name: 'Uds. Inspección',
        url: '/campanias/unidadesinspeccion',
        icon: 'icon-buscador_unidades_inspeccion',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_UDS_INSPECCION,
    },
    {
        name: 'Ud. Inspección',
        url: '/campanias/unidadinspeccion',
        icon: 'icon-unidad_inspeccion',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.MENU_UDS_INSPECCION,
        children: [
            {
                name: 'Datos Básicos',
                url: '/campanias/unidadinspeccion/datosbasicos/detail',
                icon: 'icon-datos_basicos',
                isUdInspeccionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BAS_UD_INSPECCION,
            },
            {
                name: 'Inspecciones',
                url: '/campanias/unidadinspeccion/inspecciones',
                icon: 'icon-inspecciones',
                isUdInspeccionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_INSPECCIONES_UI,
            },
            {
                name: 'Documentos',
                url: '/campanias/unidadinspeccion/documentos',
                icon: 'icon-documentos',
                isUdInspeccionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_UI,
            },
            {
                name: 'Comentarios',
                url: '/campanias/unidadinspeccion/comentarios',
                icon: 'icon-resumen',
                isUdInspeccionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_COMENTARIOS_UI,
            },
            {
                name: 'Cortes/Autorización Kgs.',
                url: '/campanias/unidadinspeccion/aforosycortes',
                icon: 'icon-aforos_cortes',
                isUdInspeccionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_AFOROS_Y_CORTES_UI,
            },
        ],
    },
    // FIN CAMPAÑAS

    //PROGRAMA VERIFICACIÓN
    {
        name: 'Programas de Verificación',
        url: '/campanias/programasverificacion',
        icon: 'icon-buscador_programas_verificacion',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.PROGRAMAS_VERIFICACION,
    },
    {
        name: 'Programa de Verificación',
        url: '/campanias/programaverificacion',
        icon: 'icon-programa_verificacion',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.PROGRAMAS_VERIFICACION,
        children: [
            {
                name: 'Datos Básicos',
                url: '/campanias/programaverificacion/datosbasicos/edit',
                icon: 'icon-datos_basicos',
                isProgramaVerificacionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_PROGRAMA_VERIFICACION,
            },
        ],
    },

    //FIN PROGRAMA VERIFICACIÓN

    //PERIODOS PARA USUARIO CA
    {
        name: 'Periodos',
        url: '/mantenimiento/periodos',
        icon: 'icon-buscador_periodos',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_CA_Y_ENTIDADES,
    },
    {
        name: 'Periodo',
        url: '/mantenimiento/periodos',
        icon: 'icon-periodo',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_CA_Y_ENTIDADES,

        children: [
            {
                name: 'Datos Básicos',
                url: '/mantenimiento/periodos/datosbasicos/edit',
                icon: 'icon-datos_basicos',
                isPeriodoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_CA_Y_ENTIDADES,
            },
            {
                name: 'Datos C.A.',
                url: '/mantenimiento/periodos/datosca',
                icon: 'icon-datos_ca',
                isPeriodoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_CA_Y_ENTIDADES,
            },
        ],
    },
    //FIN PERIODOS PARA USUARIO CA

    //IMPORTACIÓN
    {
        title: true,
        name: 'Importación',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD,
    },
    {
        name: 'Solicitudes',
        url: '/importacion/solicitudes',
        icon: 'icon-buscador_solicitudes_import',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD,
    },

    {
        //{
        //    name: 'Solicitudes',
        //    url: '/importacion/buscadores/solicitudes',
        //    icon: 'fa fa-envira'
        //},

        name: 'Solicitud',
        url: '/importacion/solicitud',
        icon: 'icon-solicitud_import',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD,
        children: [
            {
                name: 'Datos Básicos',
                url: '/importacion/solicitud/datosbasicos',
                icon: 'icon-datos_basicos',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS,
            },
            {
                name: 'Productos',
                url: '/importacion/solicitud/productos',
                icon: 'icon-productos',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS,
            },
            {
                name: 'Importador | Lugar Destino',
                url: '/importacion/solicitud/importadorlugardestino',
                icon: 'icon-bulk_cas',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_IMPORTADOR_LUGAR_DESTINO,
            },
            {
                name: 'Tasas',
                url: '/importacion/solicitud/tasas',
                icon: 'icon-tasas',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_TASAS,
            },
            {
                name: 'Documentos',
                url: '/importacion/solicitud/documentos',
                icon: 'icon-documentos',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS,
            },
            {
                name: 'Inspecciones',
                url: '/importacion/solicitud/inspecciones',
                icon: 'icon-inspecciones',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_INSPECCIONES,
            },
            {
                name: 'Laboratorio',
                url: '/importacion/solicitud/laboratorio',
                icon: 'icon-laboratorio',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_LABORATORIO,
            },
            {
                name: 'Anulación',
                url: '/importacion/solicitud/anulacion',
                icon: 'icon-anulacion',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_ANULACION,
            },
            {
                name: 'Seguimiento',
                url: '/importacion/solicitud/seguimientos',
                icon: 'icon-seguimiento',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO,
            },
            {
                name: 'PreDUA',
                url: '/importacion/solicitud/predua',
                icon: 'icon-preDUA',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_PREDUA,
            },
            {
                name: 'Previa',
                url: '/importacion/solicitud/previa',
                icon: 'icon-previa',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_PREVIA,
            },
            //{
            //    name: 'Otros Datos',
            //    url: '/importacion/solicitud/otrosdatos',
            //    icon: 'fa fa-sticky-note',
            //    isImportDetail: true,
            //    actionCode: EnumCodigosTwTcAcciones.MENU_OTROS_DATOS
            //},
            {
                name: 'Envíos',
                url: '/importacion/solicitud/envio',
                icon: 'icon-envios',
                isImportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO,
            },
            //{
            //  name: '',
            //  url: '',
            //  icon: ''
            //}

            /*
                Productos
                Tasas
                Documentos
                Inspecciones
                Anulación
                Seguimiento
                PreDUA
                Previa
                Otros Datos
                */
        ],
    },
    {
        name: 'Productos',
        url: '/importacion/productos',
        icon: 'icon-buscador_productos_import',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD,
    },

    {
        title: true,
        name: 'Importación',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_TITULO_IMPORTACION_ADMIN, //Esta acción permite visualizar el título cuando entras como Administrador
    },
    {
        name: 'Rechazos de TRACES',
        url: '/importacion/rechazostraces',
        icon: 'icon-buscador_rechazos_traces',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES,
    },
    {
        name: 'Rechazo',
        url: '/importacion/rechazostraces',
        icon: 'icon-rechazo_traces',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES,
        children: [
            {
                name: 'Parte I',
                url: '/importacion/rechazostraces/partei',
                icon: 'icon-rechazo_traces_parte_i',
                isRechazoTracesDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES,
            },
            {
                name: 'Parte II',
                url: '/importacion/rechazostraces/parteii',
                icon: 'icon-rechazo_traces_parte_ii',
                isRechazoTracesDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES,
            },
            {
                name: 'No cumplimiento',
                url: '/importacion/rechazostraces/nocumplimiento',
                icon: 'icon-rechazo_traces_no_cumplimiento',
                isRechazoTracesDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES,
            },
        ],
    },
    {
        name: 'Traslados de TRACES',
        url: '/importacion/trasladostraces',
        icon: 'icon-buscador_traslados_traces',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_TRASLADOS_TRACES,
    },
    {
        name: 'Traslado',
        url: '/importacion/trasladostraces',
        icon: 'icon-traslado_traces',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.MENU_TRASLADOS_TRACES,
        children: [
            {
                name: 'Parte I',
                url: '/importacion/trasladostraces/partei',
                icon: 'icon-rechazo_traces_parte_i',
                isTrasladoTracesDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_TRASLADOS_TRACES,
            },
            {
                name: 'Parte II',
                url: '/importacion/trasladostraces/parteii',
                icon: 'icon-rechazo_traces_parte_ii',
                isTrasladoTracesDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_TRASLADOS_TRACES,
            },
        ],
    },
    //FIN DE IMPORTACIÓN

    //EXPORTACIÓN
    {
        title: true,
        name: 'Exportación',
        loginMenuType: LoginMenuTypeEnum.Always,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD_EXPORTACION,
    },
    {
        name: 'Solicitudes',
        url: '/exportacion/solicitudes',
        icon: 'icon-buscador_solicitudes_export',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD_EXPORTACION,
    },

    {
        //{
        //    name: 'Solicitudes',
        //    url: '/importacion/buscadores/solicitudes',
        //    icon: 'fa fa-envira'
        //},

        name: 'Solicitud',
        url: '/exportacion/solicitud',
        icon: 'icon-solicitud_export',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD_EXPORTACION,
        children: [
            {
                name: 'Datos Básicos',
                url: '/exportacion/solicitud/datosbasicosEx',
                icon: 'icon-datos_basicos',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_EXPORTACION,
            },
            {
                name: 'Productos',
                url: '/exportacion/solicitud/productosEx',
                icon: 'icon-productos',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS_EXPORTACION,
            },
            {
                name: 'Tasas',
                url: '/exportacion/solicitud/tasasEx',
                icon: 'icon-tasas',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_TASAS_EXPORTACION,
            },
            {
                name: 'Documentos',
                url: '/exportacion/solicitud/documentosEx',
                icon: 'icon-documentos',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_EXPORTACION,
            },
            {
                name: 'Inspecciones',
                url: '/exportacion/solicitud/inspeccionesEx',
                icon: 'icon-inspecciones',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_INSPECCIONES_EXPORTACION,
            },
            {
                name: 'Laboratorio',
                url: '/exportacion/solicitud/laboratorioEx',
                icon: 'icon-laboratorio',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_LABORATORIO_EXPORTACION,
            },
            {
                name: 'Alegaciones',
                url: '/exportacion/solicitud/alegacionEx',
                icon: 'icon-alegaciones',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_ALEGACIONES,
            },
            {
                name: 'Anulación',
                url: '/exportacion/solicitud/anulacionEx',
                icon: 'icon-anulacion',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_ANULACION_EXPORTACION,
            },
            {
                name: 'Decl. Adicional',
                url: '/exportacion/solicitud/declSuplementariaEx',
                icon: 'icon-declaracion_adicional',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DECLSUPLEMENTARIA_EXPORTACION,
            },
            {
                name: 'Previa',
                url: '/exportacion/solicitud/previaEx',
                icon: 'icon-previa',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_PREVIA_EXPORTACION,
            },
            {
                name: 'Re-Exportación',
                url: '/exportacion/solicitud/reexportacion',
                icon: 'icon-re-exportacion',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_REEXPORTACION,
            },
            {
                name: 'Atestaciones',
                url: '/exportacion/solicitud/atestaciones',
                icon: 'icon-atestacion',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_RELACION_ATESTACIONES_EXPORTACION,
            },

            {
                name: 'Seguimiento',
                url: '/exportacion/solicitud/seguimientosEx',
                icon: 'icon-seguimiento',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION,
            },

            //{
            //    name: 'Otros Datos',
            //    url: '/importacion/solicitud/otrosdatos',
            //    icon: 'fa fa-sticky-note',
            //    isExportDetail: true,
            //    actionCode: EnumCodigosTwTcAcciones.MENU_OTROS_DATOS
            //},
            {
                name: 'Envíos',
                url: '/exportacion/solicitud/envioEx',
                icon: 'icon-envios',
                isExportDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO_EXPORTACION,
            },
        ],
    },

    {
        name: 'Productos',
        url: '/exportacion/productos',
        icon: 'icon-buscador_productos_export',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD_EXPORTACION,
    },

    {
        name: 'Verificar Certificado',
        url: '/exportacion/verificarcertificado',
        icon: 'icon-verificar_certificado',
        loginMenuType: LoginMenuTypeEnum.Always,
    },

    //ATESTACIONES
    {
        name: 'Atestaciones',
        url: '/exportacion/atestaciones',
        icon: 'icon-buscador_atestaciones',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD_ATESTACION,
    },

    {
        name: 'Atestación',
        url: '/exportacion/atestacion',
        icon: 'icon-atestacion',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD_ATESTACION,
        children: [
            {
                name: 'Datos Básicos',
                url: '/exportacion/atestacion/datosbasicos',
                icon: 'icon-datos_basicos',
                isAtestacionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_ATESTACION,
            },

            {
                name: 'Lugar Producción',
                url: '/exportacion/atestacion/lugarproduccion',
                icon: 'icon-lugar_produccion',
                isAtestacionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_LUGAR_PRODUCCION_ATESTACION,
            },

            {
                name: 'Productos',
                url: '/exportacion/atestacion/productos',
                icon: 'icon-productos',
                isAtestacionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS_ATESTACION,
            },

            {
                name: 'Documentos',
                url: '/exportacion/atestacion/documentos',
                icon: 'icon-documentos',
                isAtestacionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_ATESTACION,
            },
            {
                name: 'Resumen',
                url: '/exportacion/atestacion/resumen',
                icon: 'icon-resumen',
                isAtestacionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_RESUMEN_ATESTACION,
            },
            {
                name: 'Atestación Fito.',
                url: '/exportacion/atestacion/texto',
                icon: 'icon-atestaciones_fitosanitarias',
                isAtestacionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_TEXTO_ATESTACION,
            },
            {
                name: 'Resultado',
                url: '/exportacion/atestacion/resultado',
                icon: 'icon-resultado',
                isAtestacionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_RESULTADO_ATESTACION,
            },
            {
                name: 'Anulación',
                url: '/exportacion/atestacion/anulacion',
                icon: 'icon-anulacion',
                isAtestacionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_ANULACION_ATESTACION,
            },
            {
                name: 'Envíos',
                url: '/exportacion/atestacion/envio',
                icon: 'icon-envios',
                isAtestacionDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO_ATESTACION,
            },
        ],
    },

    //CERTIFICADOS FITO
    {
        name: 'Certificados Fitosanitarios',
        url: '/exportacion/certificadosfs',
        icon: 'icon-buscador_certificados_fitosanitarios',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.BUSCADOR_CFS,
    },
    //CERT.PREVIO EXPORTACIÓN
    {
        name: 'CPE',
        url: '/exportacion/cpes',
        icon: 'icon-buscador_cpe',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD_CPE,
    },
    {
        name: 'CPE',
        url: '/exportacion/cpe',
        icon: 'icon-cpe',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.SOLICITUD_CPE,
        children: [
            {
                name: 'Datos Básicos',
                url: '/exportacion/cpe/datosbasicos',
                icon: 'icon-datos_basicos',
                isCpeDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_CPE,
            },

            {
                name: 'Lugar Producción',
                url: '/exportacion/cpe/lugarproduccion',
                icon: 'icon-lugar_produccion',
                isCpeDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_LUGAR_PRODUCCION_CPE,
            },

            {
                name: 'Productos',
                url: '/exportacion/cpe/productos',
                icon: 'icon-productos',
                isCpeDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS_CPE,
            },

            {
                name: 'Documentos',
                url: '/exportacion/cpe/documentos',
                icon: 'icon-documentos',
                isCpeDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_CPE,
            },
            {
                name: 'Certificación',
                url: '/exportacion/cpe/certificacion',
                icon: 'icon-certificacion',
                isCpeDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_CERTIFICACION_CPE,
            },
            {
                name: 'Anulación',
                url: '/exportacion/cpe/anulacion',
                icon: 'icon-anulacion',
                isCpeDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_ANULACION_CPE,
            },
            {
                name: 'Envío',
                url: '/exportacion/cpe/envio',
                icon: 'icon-envios',
                isCpeDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO_CPE,
            },
        ],
    },

    //FIN De EXPORTACIÓN

    //SECCIÓN MANTENIMIENTOS
    {
        title: true,
        name: 'Mantenimientos',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
    },
    {
        name: 'Generales',
        url: '/mantenimiento/general',
        icon: 'icon-generales',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,

        children: [
            {
                name: 'Países',
                url: '/mantenimiento/general/paises',
                icon: 'icon-paises',
            },
            {
                name: 'Comunidades Autónomas',
                url: '/mantenimiento/general/comunidadautonoma',
                icon: 'icon-comunidades_autonomas',
            },
            {
                name: 'Puntos de Inspección',
                url: '/mantenimiento/general/puntosinspeccion',
                icon: 'icon-puntos_inspeccion',
            },
            {
                name: 'Distr. Solicitudes Export UK',
                url: '/mantenimiento/general/cargassolicitudespcfex',
                icon: 'icon-distribucion_solicitudes_export',
            },
            {
                name: 'Ubicaciones',
                url: '/mantenimiento/general/ubicaciones',
                icon: 'icon-ubicaciones',
            },
            {
                name: 'Puntos de Control',
                url: '/mantenimiento/general/puntoscontrol',
                icon: 'icon-puntos_control',
            },
            {
                name: 'Instalac. Autorizadas',
                url: '/mantenimiento/general/instalacionesautorizadas',
                icon: 'icon-instalaciones_autorizadas',
            },
            {
                name: 'Destinos de Control',
                url: '/mantenimiento/general/destinoscontrol',
                icon: 'icon-destinos_control',
            },
            {
                name: 'Declaraciones Sup.',
                url: '/mantenimiento/general/declaracionsuplementaria',
                icon: 'icon-declaraciones_suplementarias',
            },
            {
                name: 'Tratamiento Desinfección',
                url: '/mantenimiento/general/tratamientodesinfeccion',
                icon: 'icon-tratamientos_desinfeccion',
            },
            {
                name: 'Empresas Deshidratadoras',
                url: '/mantenimiento/general/empresasdeshidratadoras',
                icon: 'icon-empresas_deshidratadoras',
            },
            {
                name: 'Errores Traces',
                url: '/mantenimiento/general/errorestraces',
                icon: 'icon-errores_traces',
            },
            {
                name: 'Solicitudes Imp.',
                url: '/mantenimiento/general/solicitudes',
                icon: 'icon-solicitudes_import',
            },
            {
                name: 'Solicitudes Exp.',
                url: '/mantenimiento/general/solicitudesEx',
                icon: 'icon-solicitudes_export',
            },
            {
                name: 'Tipos de Bultos',
                url: '/mantenimiento/general/tipobulto',
                icon: 'icon-tipos_bultos',
            },
            {
                name: 'Tipos Documentación',
                url: '/mantenimiento/general/tipodocumentacion',
                icon: 'icon-tipos_documentacion_import',
            },
            {
                name: 'Tipos Documentación Ex',
                url: '/mantenimiento/general/tipodocumentacionex',
                icon: 'icon-tipos_documentacion_export',
            },
            {
                name: 'Tipos Documentación Cam',
                url: '/mantenimiento/general/tipodocumentacioncam',
                icon: 'icon-tipos_documentacion_campanias',
            },
            /*{ Todo:agaro. Comentado ahora este mantenimiento al ser de exportación.
                name: 'Insp. No Nacionales',
                url: '/mantenimiento/general/inspectorextranjero',
                icon: 'fa fa-user-secret'
            },*/
            {
                name: 'MRNs',
                url: '/mantenimiento/general/mrn',
                icon: 'icon-mrns',
            },
            {
                name: 'Municipios',
                url: '/mantenimiento/general/municipios',
                icon: 'icon-municipios',
            },
            {
                name: 'Números de Seguridad',
                url: '/mantenimiento/general/numerosseguridad',
                icon: 'icon-numeros_seguridad',
            },
            {
                name: 'Transición Estados Uds. Ins.',
                url: '/mantenimiento/general/transicionestadoudinspeccioncam',
                icon: 'icon-unidad_inspeccion',
            },
            {
                name: 'CFs Sede SL',
                url: '/mantenimiento/general/certificadosSedeExporSL',
                icon: 'icon-declaraciones_suplementarias',
            },
        ],
    },
    {
        name: 'Especies',
        url: '/mantenimiento/especies',
        icon: 'icon-especies',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,

        children: [
            {
                name: 'Códigos Eppo',
                url: '/mantenimiento/especies/codigoseppo',
                icon: 'icon-codigos_eppo',
            },
            {
                name: 'Nombres Científicos',
                url: '/mantenimiento/especies/nombrescientificos',
                icon: 'icon-nombres_cientificos',
            },
            {
                name: 'Grupos y Formas',
                url: '/mantenimiento/especies/grupos',
                icon: 'icon-grupos_formas',
            },
            {
                name: 'Especies (Grupos/Formas)',
                url: '/mantenimiento/especies/especiesgruposformas',
                icon: 'icon-especies_grupos_formas',
            },
            {
                name: 'Variedades',
                url: '/mantenimiento/especies/variedades',
                icon: 'icon-variedades',
            },
            {
                name: 'Restricciones Prod. Exp.',
                url: '/mantenimiento/especies/restriccionproductosex',
                icon: 'icon-restricciones_productos_export',
            },
            {
                name: 'Organismos Nocivos',
                url: '/mantenimiento/especies/organismosnocivos',
                icon: 'icon-organismos_nocivos',
            },
            {
                name: 'Panel productos',
                url: '/mantenimiento/especies/panelproductos',
                icon: 'icon-generales',
            },
            {
                name: 'Configuración por Taric',
                url: '/mantenimiento/especies/configuraciontaric',
                icon: 'icon-configuracion_taric',
            },
        ],
    },

    {
        name: 'Aforos',
        url: '/mantenimiento/aforos',
        icon: 'icon-buscador_aforos',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_AFOROS,
    },
    {
        name: 'Campañas',
        url: '/mantenimiento/campanias',
        icon: 'icon-buscador_campanias',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
    },
    {
        name: 'Campaña',
        url: '/mantenimiento/campania',
        icon: 'icon-campania',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
        children: [
            {
                name: 'Datos Básicos',
                url: '/mantenimiento/campania/edit',
                icon: 'icon-datos_basicos',
                isCamDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
            {
                name: 'Documentación',
                url: '/mantenimiento/campania/documentacion',
                icon: 'icon-documentos',
                isCamDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
        ],
    },
    // @adua: revisar los path para navegar y los iconos
    {
        name: 'Periodos',
        url: '/mantenimiento/periodos',
        icon: 'icon-buscador_periodos',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
    },
    {
        name: 'Periodo',
        url: '/mantenimiento/periodos',
        icon: 'icon-periodo',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,

        children: [
            {
                name: 'Datos Básicos',
                url: '/mantenimiento/periodos/datosbasicos/edit',
                icon: 'icon-datos_basicos',
                isPeriodoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
            {
                name: 'Ámbito',
                url: '/mantenimiento/periodos/ambito',
                icon: 'icon-ambito',
                isPeriodoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
            {
                name: 'Plazos',
                url: '/mantenimiento/periodos/plazos',
                icon: 'icon-plazos',
                isPeriodoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
            {
                name: 'Especies-Variedades',
                url: '/mantenimiento/periodos/especies',
                icon: 'icon-especies_variedades',
                isPeriodoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
            {
                name: 'Inspecciones',
                url: '/mantenimiento/periodos/inspecciones',
                icon: 'icon-inspecciones',
                isPeriodoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
            {
                name: 'Datos C.A.',
                url: '/mantenimiento/periodos/listadatosca',
                icon: 'icon-datos_ca',
                isPeriodoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
        ],
    },
    {
        name: 'Envíos',
        url: '/mantenimiento/envios',
        icon: 'icon-envios',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,

        children: [
            {
                name: 'Envío Aduanas',
                url: '/mantenimiento/envios/aduanas',
                icon: 'icon-envios_aduanas',
            },
            {
                name: 'Envío Aduanas V3',
                url: '/mantenimiento/envios/aduanasv3',
                icon: 'icon-envios_aduanas',
            },
            {
                name: 'Envío Traces',
                url: '/mantenimiento/envios/traces',
                icon: 'icon-envios_traces',
            },
            {
                name: 'Envío Ephyto',
                url: '/mantenimiento/envios/ephyto',
                icon: 'icon-envios_ephyto',
            },
            {
                name: 'Envío Documento Traces',
                url: '/mantenimiento/envios/documentostraces',
                icon: 'icon-envios_traces',
            },
            {
                name: 'Log',
                url: '/mantenimiento/envios/serilog',
                icon: 'icon-envios_logs',
            },
        ],
    },
    {
        name: 'Alertas',
        url: '/mantenimiento/alertas',
        icon: 'icon-alertas',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,

        children: [
            {
                name: 'Rechazos Imp. Productos',
                url: '/mantenimiento/alertas/alertaproductorechazado',
                icon: 'icon-alertas_rechazos_productos_import',
            },
            {
                name: 'Rechazos Imp. Matrículas',
                url: '/mantenimiento/alertas/alertamatricularechazada',
                icon: 'icon-alertas_rechazos_matriculas_import',
            },
            {
                name: 'Rechazos Exp. Productos',
                url: '/mantenimiento/alertas/alertaproductorechazadoex',
                icon: 'icon-alertas_rechazos_productos_export',
            },
        ],
    },
    {
        name: 'Registros',
        url: '/mantenimiento/registros',
        icon: 'icon-registros',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_AGENTES_CONTROL,

        children: [
            {
                name: 'Exportadores',
                url: '/mantenimiento/registros/exportadores',
                icon: 'icon-exportadores',
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
            {
                name: 'Entidades Auditoras',
                url: '/mantenimiento/registros/entidadesauditoras',
                icon: 'icon-entidades_auditoras',
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
            {
                name: 'Agentes de Control',
                url: '/mantenimiento/registros/agentescontrol',
                icon: 'icon-agentes_control',
                loginMenuType: LoginMenuTypeEnum.LoggedIn,
                actionCode: EnumCodigosTwTcAcciones.MENU_AGENTES_CONTROL,
            },
            {
                name: 'Almacenes', // Antiguo 'Códigos Confección'
                url: '/mantenimiento/registros/codigosconfeccion',
                icon: 'icon-almacenes',
            },

            {
                name: 'Registro Sanitario (RGSA)', // TwTcCodigoConfeccionCam_Importacion
                url: '/mantenimiento/registros/registrossanitarios',
                icon: 'icon-registro_sanitario',
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
            {
                name: 'Instalaciones',
                url: '/mantenimiento/registros/instalaciones',
                icon: 'icon-instalaciones',
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
            {
                name: 'Laboratorios',
                url: '/mantenimiento/registros/laboratorios',
                icon: 'icon-laboratorio',
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
        ],
    },

    {
        name: 'Frecuencia Reducida',
        url: '/mantenimiento/frecuenciareducida',
        icon: 'icon-frecuencia_reducida',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,

        children: [
            {
                name: 'Grupos Países FR',
                url: '/mantenimiento/frecuenciareducida/grupospaisesfr',
                icon: 'icon-frecuencia_reducida_paises',
            },
            {
                name: 'Países FR',
                url: '/mantenimiento/frecuenciareducida/paisesfr',
                icon: 'icon-frecuencia_reducida_paises',
            },
            {
                name: 'Grupos Taric FR',
                url: '/mantenimiento/frecuenciareducida/grupostaricfr',
                icon: 'icon-frecuencia_reducida_grupos_taric_import',
            },
            {
                name: 'Grupos Taric FR Higiene',
                url: '/mantenimiento/frecuenciareducida/grupostaricfrsanidadexterior',
                icon: 'icon-frecuencia_reducida_grupos_taric_import',
            },
            {
                name: 'Grupos Especies FR',
                url: '/mantenimiento/frecuenciareducida/gruposespeciesfr',
                icon: 'icon-frecuencia_reducida_grupos_especies_import',
            },
            {
                name: 'Grupos Taric FR EX',
                url: '/mantenimiento/frecuenciareducida/grupostaricfrex',
                icon: 'icon-frecuencia_reducida_grupos_taric_export',
            },
            {
                name: 'Grupos Especies FR EX',
                url: '/mantenimiento/frecuenciareducida/gruposespeciesfrex',
                icon: 'icon-frecuencia_reducida_grupos_especies_export',
            },
        ],
    },

    {
        name: 'Permisos',
        url: '/mantenimiento/permisos',
        icon: 'icon-permisos',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
        children: [
            {
                name: 'Permisos',
                url: '/mantenimiento/permisos/accionesperfiltipoestado',
                icon: 'icon-permisos_import',
                actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
            },
            {
                name: 'Permisos CPE',
                url: '/mantenimiento/permisos/permisosaccionescpe',
                icon: 'icon-permisos_cpe',
                actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
            },
            {
                name: 'Permisos Exportación',
                url: '/mantenimiento/permisos/accionesperfiltipoestadoEx',
                icon: 'icon-permisos_export',
                actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
            },
            {
                name: 'Permisos Campañas',
                url: '/mantenimiento/permisos/permisosaccionescam',
                icon: 'icon-permisos_campanias',
                actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
            },
            {
                name: 'Permisos Uds. Ins. Cam.',
                url: '/mantenimiento/permisos/permisosaccionesudsinpeccioncam',
                icon: 'icon-permisos_uds_ins_cam',
                actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
            },
            {
                name: 'Permisos Atestaciones Fito.',
                url: '/mantenimiento/permisos/permisosaccionesatestfito',
                icon: 'icon-permisos_atestaciones_fitosanitarias',
                actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
            },
            {
                name: 'Permisos P.V.',
                url: '/mantenimiento/permisos/permisosaccionespv',
                icon: 'icon-permisos_programa_verificacion',
                actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
            },
            {
                name: 'Permisos Impresos I y III',
                url: '/mantenimiento/permisos/permisosaccionesimpresosiyiii',
                icon: 'icon-permisos_programa_verificacion',
                actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
            },
        ],
    },

    //SECCIÓN GLOBAL
    {
        title: true,
        name: 'Global',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
    },
    {
        name: 'Informes',
        url: '/global/informes',
        icon: 'icon-informes',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.INFORMES_GENERALES,
    },

    {
        name: 'Usuarios Cexveg',
        url: '/mantenimiento/usuarios/usuarioscexveg',
        icon: 'icon-usuarios_cexveg',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.USUARIOS_CEXVEG,
    },

    {
        name: 'Usuarios Externos',
        url: '/mantenimiento/usuarios/usuariosexternos',
        icon: 'icon-usuarios_externos',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.USUARIOS_EXTERNOS,
    },

    {
        name: 'Usuarios Migración',
        url: '/mantenimiento/usuarios/usuariosmigracion',
        icon: 'icon-usuarios_migracion',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.USUARIOS_MIGRACION,
    },

    {
        name: 'Bulk CAS',
        url: '/mantenimiento/usuarios/bulkcas',
        icon: 'icon-bulk_cas',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
    },

    {
        name: 'Mis datos',
        url: '/mantenimiento/usuarios/usuariosexternos/editmisdatos',
        icon: 'icon-mis_datos',
        isUserDetail: true,
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MISDATOS_USREXTERNO,
        /*class: 'mt-auto'
        variant: 'success'*/
    },

    {
        name: 'Reglas de Correo',
        url: '/global/correosusuario',
        icon: 'icon-reglas_correo',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        actionCode: EnumCodigosTwTcAcciones.MENU_REGLAS_CORREO,
        /*class: 'mt-auto'
        variant: 'success'*/
    },

    {
        name: 'B. Especies',
        url: '/global/buscadorEspecies',
        icon: 'icon-buscador_especies',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        /*class: 'mt-auto'
        variant: 'success'*/
    },
    {
        title: true,
        name: 'Comunes',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
    },
    //{
    //    name: 'Mis Datos',
    //    url: '/mantenimiento/usuarios/usuariosexternos',
    //    isUserDetail: true,
    //    icon: 'fa fa-user-plus',
    //    loginMenuType: LoginMenuTypeEnum.LoggedIn,
    //    actionCode: EnumCodigosTwTcAcciones.MISDATOS_USREXTERNO
    //    /*class: 'mt-auto'
    //    variant: 'success'*/
    //},
    {
        name: 'Registro',
        //url: '/mantenimiento/usuarios/registrousuariosexternos',
        url: '/mantenimiento/usuarios/usuariosexternos/create',
        icon: 'icon-registro_usuarios_externos',
        loginMenuType: LoginMenuTypeEnum.LoggedOut,
        /*class: 'mt-auto'
        variant: 'success'*/
    },
    {
        name: 'Instrucciones',
        url: '/instrucciones',
        icon: 'icon-instrucciones',
        loginMenuType: LoginMenuTypeEnum.LoggedOut,
        /*class: 'mt-auto'
        variant: 'success'*/
    },
    {
        name: 'Pol. Protección Datos',
        url: '/protecciondatos',
        icon: 'icon-proteccion_datos',
        loginMenuType: LoginMenuTypeEnum.LoggedOut,
    },

    {
        name: 'Soporte',
        url: '/soporte',
        icon: 'icon-soporte',
        loginMenuType: LoginMenuTypeEnum.Always,
        /*class: 'mt-auto'
        variant: 'success'*/
    },
    {
        name: 'Acerca de',
        url: '/about',
        icon: 'icon-acerca_de',
        loginMenuType: LoginMenuTypeEnum.Always,
    },
    // GESTOR DE CONTENIDOS
    {
        name: 'Noticias y Avisos',
        url: '/gestorcontenidos',
        icon: 'icon-noticias_avisos',
        loginMenuType: LoginMenuTypeEnum.Always,
    },
    // ASISTENTES DE SEDE
    //{
    //    name: 'Asistente para Alta de Usuario Externo',
    //    url: '/sede/asistentes/altausuariosexternos/create',
    //    icon: 'icon-registro_usuarios_externos',
    //    loginMenuType: LoginMenuTypeEnum.LoggedOut,
    //},
    // EDICIÓN DE UN CONTENIDO
    {
        name: 'Gestor de Contenidos',
        url: '/gestorcontenidos/detail',
        icon: 'icon-gestor_contenidos',
        loginMenuType: LoginMenuTypeEnum.LoggedIn,
        visibleAfterSearching: true,
        actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
        children: [
            {
                name: 'Datos del Contenido',
                url: '/gestorcontenidos/detail/edit',
                icon: 'icon-gestor_contenidos',
                isContenidoDetail: true,
                actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
            },
        ],
    },
];
